import { ActionPlanPage } from '@features/action-plans/components/ActionPlanPage';
import { findActionPlanForRoute, getActionPlanSubjectSlug } from '@features/action-plans/helpers';
import { studentActionPlansQueryOptions } from '@features/action-plans/queries';
import { createFileRoute, notFound, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/students/$studentNo/action-plans/academic-support/$subjectSlug')({
    loader: async ({ context, params }) => {
        const actionPlans = await context.queryClient.ensureQueryData(studentActionPlansQueryOptions(params.studentNo));
        const actionPlan = findActionPlanForRoute(actionPlans, 'academic-support', params.subjectSlug);

        if (!actionPlan) {
            throw notFound();
        }

        const canonicalSubjectSlug = getActionPlanSubjectSlug(actionPlan);
        if (!canonicalSubjectSlug) {
            throw notFound();
        }

        if (params.subjectSlug !== canonicalSubjectSlug) {
            throw redirect({
                to: '/students/$studentNo/action-plans/academic-support/$subjectSlug',
                params: {
                    studentNo: params.studentNo,
                    subjectSlug: canonicalSubjectSlug,
                },
            });
        }

        return actionPlan;
    },
    component: RouteComponent,
});

function RouteComponent() {
    const actionPlan = Route.useLoaderData();
    const { studentNo } = Route.useParams();

    return <ActionPlanPage studentNo={studentNo} actionPlan={actionPlan} />;
}
